import { ProductType } from '@/types';
import { getHasWarning } from './getHasWarning';
import { WarningTypes } from './warningTypes';

export const getHasSleeves = (productType: ProductType) =>
  getHasWarning(productType, WarningTypes.HasSleeves);
